import { render } from "./InvoiceSettlementAccordion.vue?vue&type=template&id=20439521"
import script from "./InvoiceSettlementAccordion.vue?vue&type=script&lang=js"
export * from "./InvoiceSettlementAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__